import type { ErrorData } from '@/lib/cc/commonType';

export type ErrorMessageField = 'desc' | 'result' | 'message';

const DEFAULT_ERROR_FIELDS: ReadonlyArray<ErrorMessageField> = ['desc', 'result', 'message'];

export function getErrorMessage(
  data: Partial<ErrorData> | undefined,
  fields: ReadonlyArray<ErrorMessageField> = DEFAULT_ERROR_FIELDS,
): string | undefined {
  for (const field of fields) {
    const value = data?.[field];
    if (typeof value === 'string' && value.trim() !== '') {
      return value;
    }
  }
  return undefined;
}
